import { createSlice } from '@reduxjs/toolkit';

export interface DocumentColumn {
  loading: boolean;
  error: string | null;
  data: any;
}

export const documentColumnInitialState: DocumentColumn = {
  data: null,
  loading: false,
  error: null,
};

export const agencyDocumentColumnSlice = createSlice({
  name: 'agencyDocumentColumns',
  initialState: documentColumnInitialState,
  reducers: {
    getAllRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getAllSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    getAllFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { getAllRequest, getAllSuccess, getAllFailure } =
  agencyDocumentColumnSlice.actions;

export default agencyDocumentColumnSlice.reducer;
